export enum QBConnectionType {
  Any = 1,
  Good = 2,
  Bad = 3,
  None = 4,
}
